import { useTranslation } from 'next-i18next/pages'
import { AVAILABILITY_OVERRIDES, DAY_OF_WEEK } from 'components/phone-availibility/PhoneAvailability.constants'
import dayjs from 'dayjs'
import { useGetLanguage } from 'hooks/useGetLanguage'
import { isWeekend } from 'utils/dayjs'

export const PhoneAvailability = () => {
  // i18n
  const { t } = useTranslation('lookingForHelp')
  const language = useGetLanguage()

  // Constants
  const today = dayjs()
  const isBetweenRegularHours = today.hour() >= 9 && today.hour() < 18
  const available = !isWeekend() && isBetweenRegularHours
  const availableButBeforeOpeningHours = !isWeekend() && today.hour() < 9
  const availableTomorrow = today.day() !== DAY_OF_WEEK.friday && today.day() !== DAY_OF_WEEK.saturday
  const phoneAvailabilityOverride = AVAILABILITY_OVERRIDES.find(
    (override) =>
      today.isBetween(override.start, override.end) && (override?.dayOfWeek?.length ? override?.dayOfWeek.includes(today.day()) : true)
  )

  if (phoneAvailabilityOverride && language in phoneAvailabilityOverride.message) return phoneAvailabilityOverride.message[language]

  if (available) return t('available')

  if (availableButBeforeOpeningHours) return t('availableButBeforeOpeningHours')

  if (availableTomorrow) return t('availableTomorrow')

  return t('availableNextMonday')
}
